// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__24l6G","checkboxCol":"Table_checkboxCol__2LKZd","emailCol":"Table_emailCol__3A74Z","actionCol":"Table_actionCol__1f7IZ"};